import { PartialRealisationAllocationLogic } from 'further-types/lp/realisation';
import { PartialRealisationAllocationLogicLabels } from 'further-ui/labels';

export const PARTIAL_REALISATION_ALLOCATION_OPTIONS = Object.values(
  PartialRealisationAllocationLogic,
).map((logic) => ({
  value: logic,
  label: PartialRealisationAllocationLogicLabels[logic],
}));
